module.exports = __webpack_public_path__ + "img/lessons.e525192d.png";